var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{attrs:{"formTitle":"Cadastro de Instituições","cols":_vm.cols,"opts":_vm.opts,"resourceUrl":_vm.resourceUrl,"descriptionProperty":"nome"}})}
var staticRenderFns = []

export { render, staticRenderFns }